export const CONTACT = {
  phone: "9035416661",
  phoneDisplay: "+91 90354 16661",
  whatsapp: "919035416661",
  locationLine: "Bengaluru · Destinations Worldwide",
  instagram: "https://www.instagram.com/templebellseventplanners/",
  facebook: "https://www.facebook.com/templebellseventplanners/",
  youtube: "https://www.youtube.com/@templebellseventplanners5285",
};

export const NAV_LINKS = [
  { label: "Home", href: "home" },
  { label: "About", href: "about" },
  { label: "Services", href: "services" },
  { label: "Gallery", href: "gallery" },
  { label: "Packages", href: "packages" },
  { label: "Stories", href: "testimonials" },
  { label: "Contact", href: "contact" },
];

export const MARQUEE_ITEMS = [
  "Full Wedding Planning",
  "Venue & Decor Styling",
  "Fine-Dining Catering",
  "Cinematic Film & Photography",
  "Bespoke Floral Artistry",
  "Sacred Ritual Curation",
];

export const SERVICES = [
  {
    id: "full-planning",
    index: "01",
    title: "Full Wedding Planning & Coordination",
    blurb:
      "From the first conversation to the final send-off, we orchestrate every detail — timelines, vendors, logistics and the quiet moments in between.",
    points: ["End-to-end planning", "Vendor curation", "On-day coordination", "Budget stewardship"],
    image:
      "https://images.unsplash.com/photo-1698802060858-f585123570cd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "venue-decor",
    index: "02",
    title: "Venue, Decor & Catering",
    blurb:
      "Spaces transformed into living stories. We design immersive settings and pair them with menus that linger long after the last toast.",
    points: ["Venue sourcing", "Set & stage design", "Floral installations", "Culinary direction"],
    image:
      "https://images.unsplash.com/photo-1665607437981-973dcd6a22bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "photo-film",
    index: "03",
    title: "Photography & Videography",
    blurb:
      "Editorial frames and cinematic films that hold the weight of a glance — crafted by artists who disappear into the day.",
    points: ["Editorial photography", "Cinematic films", "Candid storytelling", "Same-day edits"],
    image:
      "https://images.unsplash.com/photo-1738851952441-2a7d17487545?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const ALBUMS = ["Haldi", "Mehndi", "Wedding", "Reception", "Couple", "Decor"];

export const GALLERY = [
  { src: "https://images.unsplash.com/photo-1665960213508-48f07086d49c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100", label: "The Vows", span: "tall", album: "Couple", featured: true },
  { src: "https://images.unsplash.com/photo-1708606811579-23b18fc48007?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100", label: "The Mandap", span: "wide", album: "Decor", featured: true },
  { src: "https://images.unsplash.com/photo-1525441273400-056e9c7517b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", label: "Floral Craft", span: "", album: "Decor", featured: false },
  { src: "https://images.unsplash.com/photo-1617724975854-70b5d0cedb0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", label: "By the Coast", span: "", album: "Couple", featured: false },
  { src: "https://images.unsplash.com/photo-1744805624954-a6686543c3ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", label: "The Stage", span: "tall", album: "Reception", featured: false },
  { src: "https://images.unsplash.com/photo-1600270172268-adc0cb64a46f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", label: "Fine Dining", span: "", album: "Reception", featured: false },
  { src: "https://images.unsplash.com/photo-1735052712464-9d24b69be5f5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", label: "First Look", span: "wide", album: "Couple", featured: false },
  { src: "https://images.unsplash.com/photo-1666811089871-a856fff33d62?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", label: "Sweet Finish", span: "", album: "Haldi", featured: false },
];

export const PACKAGES = [
  {
    id: "intimate",
    name: "The Intimate Ritual",
    note: "Up to 100 guests",
    price: "From ₹6,50,000",
    features: ["Planning & day coordination", "Curated single venue", "Essential decor & florals", "Half-day photography", "Guest concierge"],
    highlighted: false,
  },
  {
    id: "grand",
    name: "The Grand Celebration",
    note: "Most chosen · up to 400 guests",
    price: "From ₹18,00,000",
    features: ["Full multi-day planning", "Venue + immersive set design", "Signature catering & bar", "Photography + cinematic film", "Dedicated 6-person crew", "Bespoke floral installations"],
    highlighted: true,
  },
  {
    id: "royal",
    name: "The Sovereign Royal",
    note: "Destination · unlimited scope",
    price: "On request",
    features: ["Destination & palace sourcing", "Creative art direction", "Luxury catering journeys", "Full film & photo studio", "Guest travel & stay desk", "24/7 private planner"],
    highlighted: false,
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "They didn't just plan our wedding — they understood it. Every ritual felt sacred, every corner looked like a painting we'll never stop living inside.",
    name: "Aarav & Meera",
    venue: "Leela Palace, Udaipur",
  },
  {
    quote:
      "We handed over the chaos and received only calm. Our families still talk about the food, the florals, and how effortless the whole day felt.",
    name: "Rohan & Ananya",
    venue: "Coastal Estate, Goa",
  },
  {
    quote:
      "The film they made plays at every family gathering. Temple Bells captured not moments, but the feeling of being loved by everyone we know.",
    name: "Kabir & Isha",
    venue: "Taj West End, Bengaluru",
  },
];
